import React from 'react';
import styled from 'styled-components';
import { CityInterface } from '../../api/citiesPage';
import CityCard from './CityCard';
import CitiesMobile from './CitiesMobile';

interface AllCities {
  cities: CityInterface[];
}

const Heading = styled.h1`
  font-family: 'Roboto', sans-serif;

  font-style: normal;
  font-weight: 700;
`;

export const citiesAmerica = [
  'austin-tours',
  'niagara-falls-usa-tours',
  'providence-tours',
  'fort-lauderdale-tours',
  'newport-tours',
  'seattle-tours',
  'mexico-tours',
  'miami-tours',
  'new-york-city-tours',
  'boston-tours',
  'st-louis-tours',
  'chicago-tours',
  'san-antonio-tours',
  'seattle-tours',
  'bar-harbor',
  'bar-harbor-tours',
  'rapid-city-tours'
];

export const citiesCanada = [
  'sydney-nova-scotia-tours',
  'saint-john-tours',
  'victoria-tours',
  'prince-edward-island-tours',
  'niagara-falls-tours-canada',
  'ottawa-tours',
  'vancouver-tours',
  'st-johns-tours',
  'sydney-tours',
  'toronto-tours',
  'halifax-tours',
  'montreal-tours'
];

export const AllCities = ({ cities }: AllCities) => {
  return (
    <div className="pt-10">
      <h2 className="font-bold lg:font-semibold text-lg lg:text-4xl text-[#333333] capitalize px-[8%] xl:px-[10%]">
        cities in canada
      </h2>
      <div className="hidden md:flex flex-wrap gap-6 w-full justify-center xl:justify-start py-8 lg:py-12 md:px-[8%] xl:px-[10%]">
        {cities
          .filter(city => citiesCanada.includes(city.city.slug))
          .map((city, index) => {
            return (
              <CityCard city={city.city} key={city.city.name} index={index} />
            );
          })}
      </div>
      <CitiesMobile cities={cities} country="canada" />
      <h2 className="font-bold lg:font-semibold text-lg lg:text-4xl text-[#333333] capitalize px-[8%] xl:px-[10%] pt-8">
        cities in america
      </h2>
      <div className="hidden md:flex flex-wrap gap-6 w-full  justify-center xl:justify-start py-8 lg:py-12 md:px-[8%] xl:px-[10%]">
        {cities
          .filter(city => citiesAmerica.includes(city.city.slug))
          .map((city, index: number) => {
            return (
              <CityCard city={city.city} key={city.city.name} index={index} />
            );
          })}
      </div>
      <CitiesMobile cities={cities} country="america" />
    </div>
  );
};
